import React, { PureComponent } from "react";
import styled from "styled-components";
import ResizeObserver from "react-resize-observer";

import MapWrapper from "../../components/MapWrapper/MapWrapper";
import EmojiMarker from "../../components/EmojiMarker/EmojiMarker";
import Menu from "../../components/Menu";

import ListView from "./ListView";
import Info from "./Info";

const OuterContainer = styled.div`
  position: relative;
  flex-grow: 1;
`;

const Blackout = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 2;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

const NothingHere = styled.div`
  background-color: white;
  font-size: 20px;
  padding: 10px;
  border-radius: 7px;
  max-width: 300px;
  text-align: center;

  @media (min-width: 575px) {
    padding: 50px;
    text-align: left;
    max-width: 500px;
  }
`;

class MapView extends PureComponent {
  state = { width: null, height: null, visibleId: null, bounds: null };
  map = null;

  componentDidMount() {
    const { allEmojis, city } = this.props;
    const bounds = [];

    if (allEmojis.length) {
      allEmojis.forEach(emoji => {
        bounds.push({ lat: emoji.lat, lng: emoji.lng });
      });
    } else if (city && city.viewport_ne_lat) {
      bounds.push({ lat: city.viewport_ne_lat, lng: city.viewport_ne_lng });
      bounds.push({ lat: city.viewport_sw_lat, lng: city.viewport_sw_lng });
    } else {
      bounds.push({ lat: city.lat, lng: city.lng });
      bounds.push({ lat: city.lat - 0.01, lng: city.lng - 0.01 });
      bounds.push({ lat: city.lat + 0.01, lng: city.lng + 0.01 });
    }

    this.setState({ bounds });
  }

  render() {
    const {
      city,
      emojis,
      party,
      isFiltered,
      selectedEmoji,
      allEmojis
    } = this.props;
    const { height, visibleId, bounds } = this.state;
    return (
      <OuterContainer>
        <Menu />
        <ResizeObserver
          onResize={rect => {
            const { width, height } = rect;

            this.setState({
              width,
              height
            });
          }}
        />
        {height && (
          <MapWrapper
            initialBounds={bounds}
            center={[city.lat, city.lng]}
            height={height}
            defaultOptions={{
              disableDefaultUI: true,
              streetViewControl: false,
              scaleControl: false,
              mapTypeControl: false,
              panControl: false,
              zoomControl: true,
              rotateControl: false,
              fullscreenControl: false
            }}
          >
            {emojis.map(emoji => (
              <EmojiMarker
                color={emoji.color}
                key={`emoji-${emoji.id}`}
                emoji={emoji}
                infoWindowVisible={visibleId === emoji.id}
                onClick={open =>
                  this.setState({ visibleId: open ? emoji.id : null })
                }
              >
                {visibleId === emoji.id && (
                  <Info
                    emoji={emoji}
                    isFiltered={isFiltered}
                    onClose={() => this.setState({ visibleId: null })}
                  />
                )}
              </EmojiMarker>
            ))}
          </MapWrapper>
        )}
        {allEmojis.length === 0 ? (
          <Blackout>
            <NothingHere>
              Geen enkele partij uit deze gemeente heeft emoji op de kaart
              geplaatst.
            </NothingHere>
          </Blackout>
        ) : null}
        <ListView
          party={party}
          city={city}
          selectedEmoji={selectedEmoji}
          emojis={emojis}
          returnUrl={`/gemeente/${city.slug}`}
        />
      </OuterContainer>
    );
  }
}

export default MapView;



// WEBPACK FOOTER //
// ./src/pages/City/MapView.js